import { MENU } from "@/content";
import { Reveal } from "@/components/landing/Reveal";

const slug = (text) => text.toLowerCase().replace(/[^a-z0-9]+/g, "-");

const bookItem = (category, item) => {
  window.dispatchEvent(
    new CustomEvent("prefill-enquiry", {
      detail: { service: category.title, item: `${item.name} (${item.price})` },
    })
  );
};

const MenuCard = ({ category, span = "" }) => {
  const Icon = category.icon;
  return (
    <article
      data-testid={`menu-category-${category.id}`}
      className={`flex flex-col rounded-2xl border border-white/10 bg-white/[0.02] p-8 transition-[border-color,background-color] duration-500 hover:border-white/25 ${span}`}
    >
      <div className="flex items-center gap-3">
        <Icon className="h-5 w-5 text-zinc-500" />
        <h3 className="font-display text-lg font-bold uppercase tracking-tight sm:text-xl">
          {category.title}
        </h3>
      </div>
      <ul className="mt-8 flex-1 divide-y divide-white/5">
        {category.items.map((item) => (
          <li
            key={item.name}
            data-testid={`menu-item-${slug(item.name)}`}
            className="flex flex-wrap items-center gap-x-4 gap-y-2 py-4"
          >
            <span className="text-sm text-zinc-300">{item.name}</span>
            <span className="hidden flex-1 border-b border-dotted border-white/10 sm:block" />
            <span className="whitespace-nowrap font-display text-base font-bold tracking-tight">
              {item.price}
            </span>
            <button
              type="button"
              onClick={() => bookItem(category, item)}
              data-testid={`menu-book-${slug(item.name)}`}
              className="shrink-0 rounded-full border border-white/15 px-3 py-1 text-[10px] font-semibold uppercase tracking-[0.15em] text-zinc-300 transition-[border-color,color,background-color,transform] duration-300 hover:-translate-y-0.5 hover:border-white hover:bg-white hover:text-black"
            >
              Book
            </button>
          </li>
        ))}
      </ul>
      {category.note && (
        <p className="mt-4 text-xs leading-relaxed text-zinc-500">{category.note}</p>
      )}
    </article>
  );
};

export const Menu = () => (
  <section id="menu" data-testid="menu-section" className="relative scroll-mt-28 border-t border-white/10 py-24 sm:py-32">
    <div className="mx-auto max-w-7xl px-6">
      <Reveal>
        <p className="font-mono text-xs uppercase tracking-[0.35em] text-zinc-400">Service menu</p>
        <h2 className="mt-4 max-w-3xl font-display text-2xl font-bold uppercase tracking-tight sm:text-4xl lg:text-5xl">
          Straightforward <span className="text-zinc-500">pricing.</span>
        </h2>
        <p className="mt-6 max-w-2xl text-sm leading-relaxed text-zinc-400 sm:text-base">
          Every offering, one menu. Pick what fits — or send an enquiry and let
          our team match you.
        </p>
      </Reveal>

      <div className="mt-16 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        {MENU.slice(0, 3).map((category, i) => (
          <Reveal key={category.id} delay={i * 0.08}>
            <MenuCard category={category} span="h-full" />
          </Reveal>
        ))}
      </div>
      <div className="mt-6 grid grid-cols-1 gap-6 md:grid-cols-2 lg:grid-cols-3">
        <Reveal delay={0.05}>
          <MenuCard category={MENU[3]} span="h-full" />
        </Reveal>
        <Reveal delay={0.15} className="lg:col-span-2">
          <MenuCard category={MENU[4]} span="h-full" />
        </Reveal>
      </div>
    </div>
  </section>
);
